import {
    Form,
    Input,
    Row,
    Col,
    Switch,
    InputNumber,
    DatePicker,
    Divider
} from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';

const EditComponent = (props: any) => {
    const apiId = 'firmware';
    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);
    const [id, setId] = useState<string>();

    useEffect(() => {
        ref?.current?.getRow?.then(async (res: any) => {
            if (res?.success === true) {
                const { id } = res.data;
                setId(id);
            }
        });
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        serviceId: 'mf',
        displayOptions: {
            width: 800
        },
        dateOptions: {
            columnNames: ['releasedAt']
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={12}>
                        <Form.Item
                            label="ID"
                            name="id"
                            tooltip="固件的唯一标识，由系统自动生成，创建后不可修改，通常仅用于系统内部关联与追溯。">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="固件名称"
                            name="firmwareName"
                            tooltip="固件的展示名称，用于在列表、升级记录等界面中识别该固件，建议包含家族与版本信息，如：ESP32系列音乐播放器固件。"
                            rules={[{ required: true, message: '固件名称!' }]}>
                            <Input placeholder="如：ESP32系列音乐播放器固件" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="固件编码"
                            name="code"
                            tooltip="固件的全局唯一编码，用于在系统内精确定位某一版本固件，建议格式：family-version，如：esp32-music-v1.0.0。"
                            rules={[{ required: true, message: '固件编码（全局唯一）!' }]}>
                            <Input placeholder="如：esp32-music-v1.0.0" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="固件家族"
                            name="family"
                            tooltip="固件家族编码，用于将同一硬件系列的多个版本归为一组，如：esp32-music。同一家族内版本号唯一；不同家族可用相同版本号。"
                            rules={[{ required: true, message: '固件家族编码!' }]}>
                            <Input placeholder="如：esp32-music" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="固件版本"
                            name="version"
                            tooltip="固件版本号，同一家族内必须唯一，如：1.0.0、v2.1.3。用于 OTA 升级时的版本比较与回滚定位。"
                            rules={[{ required: true, message: '固件版本号（同family内唯一）!' }]}>
                            <Input placeholder="如：1.0.0 / v2.1.3" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="默认文件路径"
                            name="filePath"
                            tooltip="默认固件文件路径/URL。当某设备型号没有专属文件时使用该文件。若所有型号共用同一 bin，仅填写此处即可。">
                            <Input placeholder="如：/firmware/esp32-music/v1.0.0.bin" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="默认文件大小(字节)"
                            name="fileSize"
                            tooltip="默认固件文件大小，单位为字节。用于 OTA 升级时展示进度与校验完整性，可留空。">
                            <InputNumber
                                style={{ width: '100%' }}
                                min={0}
                                placeholder="如：1048576"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="默认SHA256"
                            name="checksum"
                            tooltip="默认固件的 SHA256 校验值，用于 OTA 升级完成后校验文件完整性，防止传输过程中损坏或被篡改，可留空。">
                            <Input placeholder="SHA256 校验值" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="推荐版本"
                            name="isRecommended"
                            valuePropName="checked"
                            initialValue={false}
                            tooltip="是否为推荐版本。标记为推荐的固件通常在批量升级/自动升级时作为首选目标，建议每个家族最多只有一个推荐版本。">
                            <Switch
                                checkedChildren="推荐"
                                unCheckedChildren="普通" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="发布日期"
                            name="releasedAt"
                            tooltip="固件的正式发布日期，用于在列表中按时间排序与筛选，可留空。">
                            <DatePicker
                                showTime
                                style={{ width: '100%' }}
                                placeholder="请选择发布日期"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="更新说明"
                            name="releaseNotes"
                            tooltip="固件的更新说明 / Release Notes，可填写本次版本的功能变更、修复内容、注意事项等，便于运维与用户了解升级内容。">
                            <Input.TextArea
                                rows={4}
                                placeholder="本次版本的更新说明..."
                            />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="排序"
                            name="sort"
                            tooltip="列表展示时的排序权重，数值越小越靠前。用于调整固件在列表中的显示顺序，默认 0。">
                            <InputNumber
                                style={{ width: 130 }} />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}
                            tooltip="固件是否启用。启用后该固件可被选择用于 OTA 升级；关闭后平台不再允许下发该固件，可用于下线问题版本。">
                            <Switch
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>
                </Row>
            )
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />);
};

export default EditComponent;